import axios from 'axios'
import qs from 'qs'
import Md5 from 'js-md5'
import mixins from '../mixin/common'
axios.interceptors.request.use(function (config) {
  // 直播域名下接口加密
  if (config.url.indexOf('live-test.360che.com') > -1 || config.url.indexOf('live.360che.com') > -1) {
    var time = ''
    if (config.method === 'post') {
      time = qs.parse(config.data).timestamp
    } else {
      time = config.params.timestamp
    }
    var md5 = Md5(time + 'uateP9a4jm7okKCw')
    config.headers['Access-Token'] = md5
  }
  return config
},
function (error) {
  return Promise.reject(error)
})
axios.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    return Promise.reject(error.response.data)
  }
)
const fetch = ({ url, body, type }) => {
  if (!body) {
    body = {}
  }
  if (url.indexOf('live-test.360che.com') > -1 || url.indexOf('live.360che.com') > -1) {
    body = mixins.methods.encryptionJson(body)
  }
  if (type === 'POST') {
    return axios.post(url, qs.stringify(body))
  } else {
    return axios.get(url, { params: body })
  }
}
export default fetch
